// Templates — outreach snippet library in localStorage.

import { useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';

const STORAGE_KEY = 'nice2job.templates';

interface Template {
  id: string;
  name: string;
  body: string;
}

function load(): Template[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') as Template[];
  } catch {
    return [];
  }
}
function save(items: Template[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export default function Templates() {
  const [items, setItems] = useState<Template[]>([]);
  const [name, setName] = useState('');
  const [body, setBody] = useState('');

  useEffect(() => setItems(load()), []);

  const add = () => {
    if (!name || !body) return;
    const next = [...items, { id: `tpl-${Date.now()}`, name, body }];
    setItems(next);
    save(next);
    setName('');
    setBody('');
  };
  const remove = (id: string) => {
    const next = items.filter((t) => t.id !== id);
    setItems(next);
    save(next);
  };
  const copy = (body: string) => navigator.clipboard.writeText(body);

  return (
    <div className="page-enter">
      <PageHeader
        eyebrow="Outreach · templates"
        title="Snippets that sound like you."
        sub="Save the openers and signoffs you reuse. Local only."
      />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 20 }}>
        <div className="card" style={{ padding: 22 }}>
          <div className="tab" style={{ marginBottom: 10 }}>New template</div>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Name (e.g. Warm intro opener)"
            style={{ ...inputStyle, marginBottom: 10 }}
          />
          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            rows={10}
            placeholder="Paste your snippet here — use {{FIRST_NAME}} etc as placeholders."
            style={{ ...inputStyle, fontFamily: 'inherit', resize: 'vertical' }}
          />
          <button className="btn accent lg" style={{ marginTop: 12 }} disabled={!name || !body} onClick={add}>
            Add template
          </button>
        </div>
        <div>
          {items.length === 0 ? (
            <div className="card empty">
              <span className="serif">No templates yet.</span>
              Save your first opener on the left.
            </div>
          ) : (
            items.map((t) => (
              <div key={t.id} className="card" style={{ padding: 18, marginBottom: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ flex: 1, fontWeight: 600, fontSize: 14 }}>{t.name}</div>
                  <button className="btn" style={{ fontSize: 11 }} onClick={() => copy(t.body)}>Copy</button>
                  <button className="btn ghost" style={{ fontSize: 11 }} onClick={() => remove(t.id)}>Delete</button>
                </div>
                <pre style={{ fontFamily: 'Fraunces, var(--cjk-serif), serif', fontSize: 13, color: 'var(--ink2)', lineHeight: 1.6, whiteSpace: 'pre-wrap', marginTop: 10 }}>
                  {t.body}
                </pre>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  width: '100%', padding: '10px 12px', border: '1px solid var(--line)', borderRadius: 8,
  fontSize: 13, fontFamily: 'Inter, var(--cjk-sans), sans-serif', background: 'var(--bg)',
};
